<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>The Emotions</span></p>
<p class="bk-title1"><span>Outline of a Theory</span></p>
<p class="authorname1"><span>Jean-Paul Sartre</span></p>
<p class="authorname2"><span>Translated from the French by<br/>Bernard Frechtman</span></p>
<p class="publisher"><span>Philosophical Library</span></p>
<p class="publisher1"><span><img alt="image" class="svg" src="images/pub.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1bff56aa